module.exports = __webpack_public_path__ + "static/wlc-image-sales-page-ocean-nichole-aow.e6d49dd1.jpg";